import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CarouselModule } from 'primeng/carousel';
import { AppButton } from '../../../../client/components/atom/app-button/app-button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-inspire-section',
  standalone: true,
  imports: [RouterLink, CarouselModule, AppButton, TranslatePipe],
  templateUrl: './inspire-section.html',
  styleUrl: './inspire-section.scss'
})
export class InspireSection {
  carouselUrls: Array<string>[] = [
    [
      '/assets/imgs/inspire_slider/dog_pillow.png',
      '/assets/imgs/inspire_slider/cat_poster.png',
      '/assets/imgs/inspire_slider/cat_phone.png'
    ],
    [
      '/assets/imgs/inspire_slider/cat_laptop.png',
      '/assets/imgs/inspire_slider/dog_cap.png',
      '/assets/imgs/inspire_slider/dog_shirt.png'
    ]
  ];
}
